import {
  ShoppingBag, ShoppingCart, Shirt, MonitorSmartphone, Home, UtensilsCrossed, Plus,
  Landmark, Layers, Car, GraduationCap, BriefcaseBusiness, Coins,
  Truck, BadgeCheck, ShieldCheck, FileText,
  Pill, Stethoscope, Hospital, Syringe, HeartPulse,
  Wrench, Flower2, Zap, Sparkles, Scissors, Dumbbell, Building2, CalendarDays, KeyRound, Tent,
} from "lucide-react";

const IMG = "/aya/verticals";

export const commerceData = {
  id: "commerce",
  hero: {
    Icon: ShoppingBag,
    iconBg: "linear-gradient(135deg,#F97316,#EA580C)",
    title: "Commerce",
    subtitle: "Tout ce que vous pouvez acheter autour de vous.",
    taglineTop: "Consommons",
    taglineGreen: "ivoirien",
    taglineSub: "Construisons demain",
  },
  searchPlaceholder: "Rechercher un produit, une boutique...",
  categories: {
    title: "Catégories",
    subtitle: "Explorez toutes nos catégories de commerce",
    items: [
      { id: "alimentation", img: `${IMG}/com_cat_alimentation.jpg`, Icon: ShoppingCart, iconBg: "#B45309", title: "Alimentation", desc: "Supermarchés & marchés" },
      { id: "mode", img: `${IMG}/com_cat_mode.jpg`, Icon: Shirt, iconBg: "#BE185D", title: "Mode & beauté", desc: "Vêtements, coiffure & accessoires" },
      { id: "electronique", img: `${IMG}/com_cat_electronique.jpg`, Icon: MonitorSmartphone, iconBg: "#1D4ED8", title: "Électronique", desc: "Téléphones & informatique" },
      { id: "maison", img: `${IMG}/com_cat_maison.jpg`, Icon: Home, iconBg: "#047857", title: "Maison", desc: "Meubles, déco & électroménager" },
      { id: "restaurants", img: `${IMG}/com_cat_restaurants.jpg`, Icon: UtensilsCrossed, iconBg: "#B45309", title: "Restaurants", desc: "Menus, livraison & réservation" },
      { id: "sante", img: `${IMG}/com_cat_sante.jpg`, Icon: Plus, iconBg: "#15803D", title: "Santé", desc: "Pharmacies & parapharmacies" },
    ],
  },
  nearby: {
    title: "Commerces près de vous",
    subtitle: "Des boutiques autour de votre position (PADA)",
    items: [
      { id: "sococe", logo: { type: "text", text: "SOCOCE", color: "#15803D", bg: "#FFFFFF" }, name: "Sococe Supermarché", area: "Riviera 2", distance: "1,2 km" },
      { id: "playce", logo: { type: "text", text: "Playce", color: "#DC2626", bg: "#FDE047" }, name: "Playce Marcory", area: "Marcory", distance: "2,4 km" },
      { id: "paix", logo: { type: "icon", Icon: Plus, color: "#15803D", bg: "#FFFFFF" }, name: "Pharmacie de la Paix", area: "Cocody", distance: "900 m" },
      { id: "chinamall", logo: { type: "text", text: "CHINA MALL", color: "#DC2626", bg: "#FFFFFF" }, name: "China Mall", area: "Treichville", distance: "3,1 km" },
    ],
  },
  live: {
    title: "AYA Live",
    subtitle: "Des commerçants en direct près de vous",
    items: [
      { id: "beauty", img: `${IMG}/com_live_beauty.jpg`, viewers: 124, title: "Beauty Ivoire", tag: "Produits de beauté" },
      { id: "mode", img: `${IMG}/com_live_mode.jpg`, viewers: 89, title: "Mode Abidjan", tag: "Chaussures & accessoires" },
      { id: "chinamall", img: `${IMG}/com_live_electro.jpg`, viewers: 256, title: "China Mall CI", tag: "Électroménager" },
      { id: "tech", img: `${IMG}/com_live_tech.jpg`, viewers: 73, title: "Tech Store", tag: "Smartphones & gadgets" },
    ],
  },
  trending: {
    title: "Tendances à Abidjan",
    subtitle: "Les produits les plus populaires en ce moment",
    ctaType: "cart",
    items: [
      { id: "riz", img: `${IMG}/com_prod_riz.jpg`, name: "Riz Local 5kg", desc: "Riz Local", rating: "4,7", reviews: "1 245", price: "2 500 FCFA" },
      { id: "tv", img: `${IMG}/com_prod_tv.jpg`, name: "Smart TV Samsung 55\"", desc: "4K UHD · Smart TV", rating: "4,5", reviews: "320", price: "350 000 FCFA" },
      { id: "nike", img: `${IMG}/com_prod_sneakers.jpg`, name: "Baskets Nike Air Force 1", desc: "Unisexe · Plusieurs tailles", rating: "4,6", reviews: "892", price: "75 000 FCFA" },
      { id: "iphone", img: `${IMG}/com_prod_iphone.jpg`, name: "iPhone 15", desc: "128 Go · Neuf", rating: "4,8", reviews: "421", price: "720 000 FCFA" },
      { id: "canape", img: `${IMG}/com_prod_canape.jpg`, name: "Canapé 3 places", desc: "Salon · Tissu premium", rating: "4,4", reviews: "310", price: "280 000 FCFA" },
    ],
  },
  trust: [
    { Icon: Truck, title: "Livraison partout à Abidjan", sub: "Rapide · Sécurisée · Suivi en temps réel" },
    { Icon: BadgeCheck, iconColor: "#E8A33D", title: "Commerçants vérifiés", sub: "Des vendeurs de confiance" },
  ],
};

export const servicesPublicsData = {
  id: "services-publics",
  hero: {
    Icon: Landmark,
    iconBg: "linear-gradient(135deg,#10B981,#0E7A4F)",
    title: "Services publics",
    subtitle: "Vos démarches administratives, plus simples et plus rapides.",
    taglineTop: "Un service public",
    taglineGreen: "plus proche des Ivoiriens",
    taglineSub: "Digitalisons ensemble",
  },
  searchPlaceholder: "Rechercher un service public, une démarche...",
  categories: {
    title: "Catégories",
    subtitle: "Explorez toutes nos catégories de services publics",
    items: [
      { id: "documents", img: `${IMG}/sp_cat_documents.jpg`, Icon: FileText, iconBg: "#1D4ED8", title: "Documents officiels", desc: "CNI, Passeport, Actes d'état civil" },
      { id: "impots", img: `${IMG}/sp_cat_impots.jpg`, Icon: Layers, iconBg: "#15803D", title: "Impôts & taxes", desc: "Paiement, suivi, attestations" },
      { id: "transport", img: `${IMG}/sp_cat_transport.jpg`, Icon: Car, iconBg: "#1D4ED8", title: "Transport", desc: "Permis, cartes grises, immatriculation" },
      { id: "education", img: `${IMG}/sp_cat_education.jpg`, Icon: GraduationCap, iconBg: "#B45309", title: "Éducation", desc: "Inscriptions, résultats, bourses" },
      { id: "emploi", img: `${IMG}/sp_cat_emploi.jpg`, Icon: BriefcaseBusiness, iconBg: "#C2410C", title: "Emploi", desc: "Offres, concours, recrutement" },
      { id: "urbanisme", img: `${IMG}/sp_cat_urbanisme.jpg`, Icon: Home, iconBg: "#15803D", title: "Urbanisme & logement", desc: "Permis, cadastre, foncier" },
    ],
  },
  nearby: {
    title: "Services publics près de vous",
    subtitle: "Les services administratifs autour de votre position (PADA)",
    items: [
      { id: "mairie-adjame", logo: { type: "icon", Icon: Landmark, color: "#15803D", bg: "#FFFFFF" }, name: "Mairie d'Adjamé", area: "Adjamé Centre", distance: "500 m" },
      { id: "prefecture", logo: { type: "icon", Icon: Landmark, color: "#FFFFFF", bg: "#EA580C" }, name: "Préfecture d'Abidjan", area: "Plateau", distance: "3,2 km" },
      { id: "tresor", logo: { type: "icon", Icon: Coins, color: "#B45309", bg: "#FFF7E0" }, name: "Trésor Public", area: "Plateau", distance: "4,1 km" },
      { id: "dgi", logo: { type: "text", text: "DGI", color: "#111827", bg: "#FFFFFF" }, name: "DGI", area: "Cocody", distance: "5,6 km" },
    ],
  },
  live: {
    title: "AYA Live",
    subtitle: "Des sessions en direct pour vous guider dans vos démarches",
    items: [
      { id: "cni", img: `${IMG}/sp_live_cni.jpg`, viewers: 124, title: "Comment faire sa CNI en ligne ?", tag: "Documents officiels" },
      { id: "impots", img: `${IMG}/sp_live_impots.jpg`, viewers: 89, title: "Déclaration d'impôts : mode d'emploi", tag: "Impôts & taxes" },
      { id: "permis", img: `${IMG}/sp_live_permis.jpg`, viewers: 256, title: "Renouvellement du permis de conduire", tag: "Transport" },
      { id: "universite", img: `${IMG}/sp_live_universite.jpg`, viewers: 73, title: "Inscriptions universitaires 2025", tag: "Éducation" },
    ],
  },
  trending: {
    title: "Démarches les plus populaires",
    subtitle: "Les services les plus demandés en ce moment",
    ctaType: "start",
    items: [
      { id: "cni", img: `${IMG}/sp_dem_cni.jpg`, name: "Carte Nationale d'Identité (CNI)", status: "En ligne", rating: "4,8", reviews: "12 450" },
      { id: "passeport", img: `${IMG}/sp_dem_passeport.jpg`, name: "Passeport", status: "En ligne", rating: "4,7", reviews: "8 230" },
      { id: "certificat", img: `${IMG}/sp_dem_certificat.jpg`, name: "Certificat de résidence", status: "En ligne", rating: "4,6", reviews: "6 120" },
      { id: "casier", img: `${IMG}/sp_dem_casier.jpg`, name: "Casier judiciaire", status: "En ligne", rating: "4,5", reviews: "4 890" },
      { id: "permis", img: `${IMG}/sp_dem_permis.jpg`, name: "Permis de conduire", status: "En ligne", rating: "4,6", reviews: "7 320" },
    ],
  },
  trust: [
    { Icon: Truck, title: "Démarches 100% en ligne", sub: "Rapide · Sécurisée · Sans déplacement" },
    { Icon: ShieldCheck, iconColor: "#E8A33D", title: "Informations officielles", sub: "Sources gouvernementales" },
  ],
};

export const santeData = {
  id: "sante",
  hero: {
    Icon: Plus,
    iconBg: "linear-gradient(135deg,#22C55E,#15803D)",
    title: "Santé",
    subtitle: "Votre santé et celle de vos proches, plus proche de vous.",
    taglineTop: "Une santé",
    taglineGreen: "pour tous les Ivoiriens",
    taglineSub: "Prévenir · Soigner · Vivre mieux",
  },
  searchPlaceholder: "Rechercher un médicament, une pharmacie, une clinique...",
  categories: {
    title: "Catégories",
    subtitle: "Explorez toutes nos catégories santé",
    items: [
      { id: "medicaments", img: `${IMG}/san_cat_medicaments.jpg`, Icon: Pill, iconBg: "#15803D", title: "Médicaments", desc: "Prescription & sans ordonnance" },
      { id: "pharmacies", img: `${IMG}/com_cat_sante.jpg`, Icon: Plus, iconBg: "#16A34A", title: "Pharmacies", desc: "Pharmacies & parapharmacies" },
      { id: "medecins", img: `${IMG}/san_cat_medecins.jpg`, Icon: Stethoscope, iconBg: "#0D9488", title: "Médecins & spécialistes", desc: "Généralistes, spécialistes" },
      { id: "cliniques", img: `${IMG}/san_cat_cliniques.jpg`, Icon: Hospital, iconBg: "#1D4ED8", title: "Cliniques & hôpitaux", desc: "Rendez-vous, services, urgences" },
      { id: "vaccination", img: `${IMG}/san_cat_vaccination.jpg`, Icon: Syringe, iconBg: "#15803D", title: "Vaccination", desc: "Calendrier vaccinal & informations" },
      { id: "bienetre", img: `${IMG}/san_cat_bienetre.jpg`, Icon: HeartPulse, iconBg: "#16A34A", title: "Santé & bien-être", desc: "Conseils, prévention & lifestyle" },
    ],
  },
  nearby: {
    title: "Services santé près de vous",
    subtitle: "Les pharmacies, cliniques et services autour de votre position (PADA)",
    items: [
      { id: "paix", logo: { type: "icon", Icon: Plus, color: "#15803D", bg: "#FFFFFF" }, name: "Pharmacie de la Paix", area: "Cocody", distance: "900 m" },
      { id: "saintemarie", logo: { type: "icon", Icon: Plus, color: "#1D4ED8", bg: "#FFFFFF" }, name: "Clinique Sainte Marie", area: "Plateau", distance: "2,1 km" },
      { id: "saintmichel", logo: { type: "text", text: "PHARMACIE", color: "#15803D", bg: "#FFFFFF" }, name: "Pharmacie Saint-Michel", area: "Marcory", distance: "2,4 km" },
      { id: "chu", logo: { type: "text", text: "H", color: "#FFFFFF", bg: "#1D4ED8" }, name: "CHU Treichville", area: "Treichville", distance: "3,3 km" },
    ],
  },
  live: {
    title: "AYA Live Santé",
    subtitle: "Des professionnels de santé en direct pour répondre à vos questions",
    items: [
      { id: "conseils", img: `${IMG}/san_live_conseils.jpg`, viewers: 124, title: "Conseils santé du quotidien", tag: "Médecine générale" },
      { id: "medicaments", img: `${IMG}/san_live_medicaments.jpg`, viewers: 89, title: "Tout savoir sur les médicaments", tag: "Pharmacie" },
      { id: "nutrition", img: `${IMG}/san_live_nutrition.jpg`, viewers: 256, title: "Nutrition & bien-être en Côte d'Ivoire", tag: "Nutrition" },
      { id: "sport", img: `${IMG}/san_live_sport.jpg`, viewers: 73, title: "Sport & santé : rester en forme", tag: "Bien-être" },
    ],
  },
  trending: {
    title: "Produits santé populaires",
    subtitle: "Les produits de santé les plus demandés en ce moment",
    ctaType: "cart",
    items: [
      { id: "doliprane", img: `${IMG}/san_prod_doliprane.jpg`, name: "Doliprane 1000mg", desc: "Paracétamol", rating: "4,7", reviews: "5 320", price: "2 500 FCFA" },
      { id: "masque", img: `${IMG}/san_prod_masque.jpg`, name: "Masque chirurgical", desc: "50 pièces", rating: "4,5", reviews: "3 890", price: "3 500 FCFA" },
      { id: "vitamine", img: `${IMG}/san_prod_vitamine.jpg`, name: "Vitamine C", desc: "100 comprimés", rating: "4,6", reviews: "2 450", price: "4 900 FCFA" },
      { id: "tensiometre", img: `${IMG}/san_prod_tensiometre.jpg`, name: "Tensiomètre", desc: "Électronique", rating: "4,4", reviews: "1 230", price: "18 000 FCFA" },
      { id: "gel", img: `${IMG}/san_prod_gel.jpg`, name: "Gel hydroalcoolique", desc: "500 ml", rating: "4,6", reviews: "4 120", price: "3 500 FCFA" },
    ],
  },
  trust: [
    { Icon: Truck, title: "Livraison partout à Abidjan", sub: "Rapide · Sécurisée · Suivi en temps réel" },
    { Icon: ShieldCheck, iconColor: "#E8A33D", title: "Produits certifiés", sub: "Médicaments authentiques" },
  ],
};

// 2026-06 — AYA SERVICES (maquette « Services » : professionnels près de vous).
export const servicesData = {
  id: "services",
  hero: {
    Icon: Wrench,
    iconBg: "linear-gradient(135deg,#F97316,#EA580C)",
    photo: `${IMG}/srv_hero.jpg`,
    title: "Services",
    subtitle: "Trouvez les professionnels dont vous avez besoin, près de vous.",
    taglineTop: "Des professionnels",
    taglineGreen: "ivoiriens",
    taglineSub: "Pour vous, plus proches",
  },
  searchPlaceholder: "Rechercher un service, un professionnel...",
  categories: {
    title: "Catégories",
    subtitle: "Explorez toutes nos catégories de services",
    items: [
      { id: "maison", img: `${IMG}/srv_cat_maison.jpg`, Icon: Wrench, iconBg: "#F97316", title: "Maison & dépannage", desc: "Plomberie, électricité..." },
      { id: "auto", img: `${IMG}/srv_cat_auto.jpg`, Icon: Car, iconBg: "#EA580C", title: "Auto & moto", desc: "Mécanique, pneumatique..." },
      { id: "beaute", img: `${IMG}/srv_cat_beaute.jpg`, Icon: Flower2, iconBg: "#EC4899", title: "Beauté & personnel", desc: "Coiffure, maquillage..." },
      { id: "pro", img: `${IMG}/srv_cat_pro.jpg`, Icon: BriefcaseBusiness, iconBg: "#B45309", title: "Services professionnels", desc: "Informatique, comptabilité..." },
      { id: "event", img: `${IMG}/srv_cat_event.jpg`, Icon: CalendarDays, iconBg: "#EA580C", title: "Événementiel", desc: "Traiteur, décoration..." },
    ],
  },
  ctaBanner: {
    Icon: Zap,
    iconBg: "linear-gradient(135deg,#F97316,#EA580C)",
    img: `${IMG}/srv_cta.jpg`,
    titlePlain: "Besoin",
    titleAccent: "maintenant ?",
    text: "Un professionnel disponible près de vous peut intervenir rapidement.",
    btn: "Trouver un professionnel maintenant",
    ctx: "J'ai besoin d'un professionnel disponible MAINTENANT près de moi (dépannage, intervention rapide). Trouve-moi quelqu'un et organise l'intervention.",
  },
  nearby: {
    variant: "pros",
    title: "Services près de vous",
    subtitle: "Des professionnels autour de votre position (PADA)",
    items: [
      { id: "kouadio", img: `${IMG}/srv_cat_maison.jpg`, name: "Kouadio Services", verified: true, rating: "4,8", reviews: "126", area: "Cocody", distance: "1,2 km", tags: ["Plomberie", "Débouchage"], availability: "now", desc: "Artisan plombier depuis 12 ans à Abidjan. Interventions rapides à domicile, devis gratuit avant chaque chantier.", hours: "Lun – Sam · 07h30 – 19h00", services: [{ name: "Dépannage plomberie", duration: "1 h", price_fcfa: 15000 }, { name: "Débouchage canalisation", duration: "1 h 30", price_fcfa: 25000 }, { name: "Installation sanitaire", duration: "3 h", price_fcfa: 40000 }] },
      { id: "electricite", img: `${IMG}/srv_pro_elec.jpg`, name: "Électricité Pro CI", verified: true, rating: "4,7", reviews: "98", area: "Angré", distance: "2,4 km", tags: ["Installation", "Panne"], availability: "now", desc: "Électricien certifié, spécialiste des pannes domestiques et mises aux normes. Matériel garanti.", hours: "Lun – Sam · 08h00 – 18h30", services: [{ name: "Diagnostic panne", duration: "45 min", price_fcfa: 10000 }, { name: "Installation électrique", duration: "2 h 30", price_fcfa: 35000 }, { name: "Mise aux normes", duration: "4 h", price_fcfa: 50000 }] },
      { id: "froidclim", img: `${IMG}/srv_cta.jpg`, name: "Froid & Clim Service", verified: true, rating: "4,9", reviews: "85", area: "Deux-Plateaux", distance: "3,1 km", tags: ["Climatisation", "Entretien"], availability: "now", desc: "Entretien, installation et recharge de climatiseurs toutes marques. Équipe disponible 6j/7.", hours: "Lun – Sam · 08h00 – 19h00", services: [{ name: "Entretien climatiseur", duration: "1 h", price_fcfa: 20000 }, { name: "Recharge gaz", duration: "1 h", price_fcfa: 30000 }, { name: "Installation split", duration: "3 h", price_fcfa: 45000 }] },
      { id: "cleanshine", img: `${IMG}/srv_pro_clean.jpg`, name: "Clean & Shine CI", verified: true, rating: "4,6", reviews: "203", area: "Riviera", distance: "2,0 km", tags: ["Ménage", "Désinfection"], availability: "resa", desc: "Équipe de nettoyage professionnelle pour maisons, bureaux et fins de chantier. Produits certifiés.", hours: "Lun – Dim · 08h00 – 18h00", services: [{ name: "Ménage standard", duration: "2 h", price_fcfa: 15000 }, { name: "Grand nettoyage", duration: "4 h", price_fcfa: 35000 }, { name: "Désinfection complète", duration: "3 h", price_fcfa: 40000 }] },
    ],
  },
  live: {
    title: "AYA Live",
    subtitle: "Des professionnels en direct près de vous",
    items: [
      { id: "plomberie", img: `${IMG}/srv_cat_maison.jpg`, viewers: 124, title: "Astuces plomberie maison", tag: "Kouadio Services" },
      { id: "coiffure", img: `${IMG}/srv_cat_beaute.jpg`, viewers: 89, title: "Coiffure à domicile : conseils", tag: "Beauty Hair CI" },
      { id: "clim", img: `${IMG}/srv_cta.jpg`, viewers: 56, title: "Entretien climatisation", tag: "Froid & Clim Service" },
      { id: "nettoyage", img: `${IMG}/srv_pro_clean.jpg`, viewers: 42, title: "Conseils nettoyage efficace", tag: "Clean & Shine CI" },
    ],
  },
  trust: [
    { Icon: Zap, title: "Intervention rapide", sub: "Des pros disponibles près de vous" },
    { Icon: BadgeCheck, iconColor: "#E8A33D", title: "Professionnels vérifiés", sub: "Identités et avis contrôlés" },
  ],
};

// 2026-06 — AYA BIEN-ÊTRE (maquette « Bien-être » : détente, beauté, équilibre).
export const bienEtreData = {
  id: "bien-etre",
  hero: {
    Icon: Flower2,
    iconBg: "linear-gradient(135deg,#EC4899,#BE185D)",
    photo: `${IMG}/be_hero.jpg`,
    title: "Bien-être",
    subtitle: "Prenez soin de vous, chez vous ou dans un établissement.",
    taglineTop: "Détente · Beauté",
    taglineGreen: "Équilibre",
    taglineSub: "Un quotidien meilleur",
  },
  searchPlaceholder: "Rechercher un massage, un spa, un coiffeur...",
  categories: {
    title: "Catégories",
    subtitle: "Explorez toutes nos catégories bien-être",
    items: [
      { id: "massage", img: `${IMG}/be_cat_massage.jpg`, Icon: Flower2, iconBg: "#EC4899", title: "Massage & spa", desc: "Relaxant, sportif, à domicile..." },
      { id: "soins", img: `${IMG}/be_cat_soins.jpg`, Icon: Sparkles, iconBg: "#BE185D", title: "Beauté & soins", desc: "Soins du visage, épilation, manucure..." },
      { id: "coiffure", img: `${IMG}/be_cat_coiffure.jpg`, Icon: Scissors, iconBg: "#EC4899", title: "Coiffure & barber", desc: "Coiffure à domicile, barber, maquillage..." },
      { id: "sport", img: `${IMG}/be_cat_sport.jpg`, Icon: Dumbbell, iconBg: "#BE185D", title: "Forme & sport", desc: "Yoga, coach sportif, pilates..." },
      { id: "etablissements", img: `${IMG}/be_cat_etab.jpg`, Icon: Building2, iconBg: "#047857", title: "Établissements", desc: "Spa, hammam, sauna, institut de beauté..." },
    ],
  },
  ctaBanner: {
    Icon: Home,
    iconBg: "linear-gradient(135deg,#F97316,#EA580C)",
    img: `${IMG}/be_cta.jpg`,
    titlePlain: "Bien-être",
    titleAccent: "à domicile",
    text: "Votre moment de détente, directement chez vous.",
    btn: "Réserver maintenant",
    ctx: "Je veux réserver une prestation bien-être à domicile (massage, soins, coiffure). Propose-moi des professionnels disponibles près de chez moi et organise la réservation.",
  },
  nearby: {
    variant: "pros",
    title: "Professionnels près de vous",
    subtitle: "Des experts bien-être autour de votre position (PADA)",
    items: [
      { id: "massagerelax", img: `${IMG}/be_cat_massage.jpg`, name: "Massage Relax Abidjan", verified: true, rating: "4,8", reviews: "126", area: "Cocody", distance: "1,2 km", tags: ["Massage à domicile", "Relaxant"], availability: "now", desc: "Masseuse diplômée, spécialisée dans le massage relaxant et sportif à domicile. Matériel fourni (table, huiles, musique).", hours: "Lun – Sam · 09h00 – 20h00", services: [{ name: "Massage relaxant 60 min", duration: "1 h", price_fcfa: 25000 }, { name: "Massage sportif", duration: "1 h", price_fcfa: 30000 }, { name: "Massage duo à domicile", duration: "1 h 30", price_fcfa: 45000 }] },
      { id: "bellevous", img: `${IMG}/be_pro_institut.jpg`, name: "Institut Belle & Vous", verified: true, rating: "4,7", reviews: "98", area: "Riviera", distance: "2,3 km", tags: ["Soins visage", "Manucure"], availability: "now", desc: "Institut de beauté premium : soins du visage, manucure, épilation. Produits professionnels hypoallergéniques.", hours: "Mar – Dim · 09h00 – 19h00", services: [{ name: "Soin visage éclat", duration: "45 min", price_fcfa: 20000 }, { name: "Manucure + pose vernis", duration: "1 h", price_fcfa: 12000 }, { name: "Épilation complète", duration: "1 h 15", price_fcfa: 18000 }] },
      { id: "barberpro", img: `${IMG}/be_pro_barber.jpg`, name: "Barber Pro CI", verified: true, rating: "4,9", reviews: "203", area: "Marcory", distance: "1,8 km", tags: ["Coupe homme", "Barber à domicile"], availability: "now", desc: "Barber expérimenté : coupes tendance, dégradés, entretien de barbe. Se déplace aussi à domicile.", hours: "Lun – Sam · 08h30 – 20h00", services: [{ name: "Coupe homme", duration: "30 min", price_fcfa: 5000 }, { name: "Coupe + barbe", duration: "45 min", price_fcfa: 8000 }, { name: "Barber à domicile", duration: "1 h", price_fcfa: 12000 }] },
      { id: "spaharmonie", img: `${IMG}/be_cat_etab.jpg`, name: "Spa Harmonie", verified: true, rating: "4,6", reviews: "94", area: "Angré", distance: "3,1 km", tags: ["Massage", "Spa privatif"], availability: "resa", desc: "Spa haut de gamme : hammam, sauna, massages et espaces privatifs duo. Réservation conseillée.", hours: "Tous les jours · 10h00 – 22h00", services: [{ name: "Accès spa 2 h", duration: "2 h", price_fcfa: 30000 }, { name: "Massage + hammam", duration: "2 h", price_fcfa: 45000 }, { name: "Spa privatif duo", duration: "2 h 30", price_fcfa: 80000 }] },
    ],
  },
  live: {
    title: "AYA Live",
    subtitle: "Des professionnels bien-être en direct près de vous",
    items: [
      { id: "soinvisage", img: `${IMG}/be_cat_soins.jpg`, viewers: 236, title: "Routine soin du visage à domicile", tag: "Institut Belle & Vous" },
      { id: "massagelive", img: `${IMG}/be_cta.jpg`, viewers: 189, title: "Massage relaxant : techniques et conseils", tag: "Spa Harmonie" },
      { id: "beaute", img: `${IMG}/be_pro_institut.jpg`, viewers: 77, title: "Conseils beauté au quotidien", tag: "Beauty Expert CI" },
      { id: "coiffurelive", img: `${IMG}/be_cat_coiffure.jpg`, viewers: 64, title: "Coiffure à domicile : tendances", tag: "Beauty Hair CI" },
    ],
  },
  trust: [
    { Icon: Home, title: "Bien-être à domicile", sub: "Des praticiens qui se déplacent chez vous" },
    { Icon: BadgeCheck, iconColor: "#E8A33D", title: "Praticiens vérifiés", sub: "Diplômes et avis contrôlés" },
  ],
};

// 2026-06 — Registre des professionnels (fiches détaillées /pro/:id).
export const PROS_REGISTRY = Object.fromEntries([
  ...servicesData.nearby.items.map((p) => [p.id, { ...p, universe: "services", universeLabel: "Services", back: "/services" }]),
  ...bienEtreData.nearby.items.map((p) => [p.id, { ...p, universe: "bien-etre", universeLabel: "Bien-être", back: "/bien-etre" }]),
]);

// 2026-06 — AYA LOCATION (maquette « Location » : biens & matériels à louer).
export const locationData = {
  id: "location",
  hero: {
    Icon: KeyRound,
    iconBg: "linear-gradient(135deg,#F97316,#EA580C)",
    photo: `${IMG}/loc_hero.jpg`,
    title: "Location",
    subtitle: "Louez ce dont vous avez besoin, près de vous.",
    taglineTop: "Logement · Véhicules",
    taglineGreen: "Matériel · Événementiel",
    taglineSub: "Des solutions pour tous vos projets",
  },
  searchPlaceholder: "Rechercher un appartement, une voiture, du matériel...",
  categories: {
    title: "Catégories",
    subtitle: "Explorez toutes nos catégories de location",
    items: [
      { id: "immobilier", img: `${IMG}/loc_cat_immo.jpg`, Icon: Home, iconBg: "#16A34A", title: "Immobilier & logements", desc: "Appartements, villas, résidences meublées..." },
      { id: "vehicules", img: `${IMG}/loc_cat_vehicules.jpg`, Icon: Car, iconBg: "#F97316", title: "Véhicules", desc: "Voitures, 4x4, minibus, motos... avec ou sans chauffeur" },
      { id: "evenementiel", img: `${IMG}/loc_cat_event.jpg`, Icon: Tent, iconBg: "#EC4899", title: "Événementiel", desc: "Sono, bâches, chaises, tables, vaisselle, déco..." },
      { id: "materiel", img: `${IMG}/loc_cat_materiel.jpg`, Icon: Wrench, iconBg: "#EAB308", title: "Matériel & équipements", desc: "BTP, outillage, groupes électrogènes, machines..." },
      { id: "professionnel", img: `${IMG}/loc_cat_pro.jpg`, Icon: BriefcaseBusiness, iconBg: "#8B5CF6", title: "Professionnel", desc: "Bureaux, locaux commerciaux, salles de réunion..." },
    ],
  },
  ctaBanner: {
    Icon: CalendarDays,
    iconBg: "linear-gradient(135deg,#F97316,#EA580C)",
    img: `${IMG}/loc_cta.jpg`,
    titlePlain: "Préparez votre",
    titleAccent: "événement ?",
    text: "Louez tout le matériel nécessaire en quelques clics.",
    btn: "Voir les packs événements",
    ctx: "Je prépare un événement et je veux louer du matériel (sono, bâches, chaises, tables, déco). Montre-moi les packs événements disponibles près de moi et aide-moi à réserver.",
  },
  nearby: {
    variant: "rentals",
    title: "Locations près de vous",
    subtitle: "Des biens et matériels autour de votre position (PADA)",
    items: [
      { id: "residencecocody", img: `${IMG}/loc_rent_apt.jpg`, name: "Résidence Cocody", verified: true, rating: "4,8", reviews: "126", area: "Riviera 2", distance: "1,2 km", tags: ["Appartement meublé", "Wi-Fi"], price_fcfa: 35000, price_prefix: "", price_unit: "/ nuit", cta: "Réserver", rental_model: { type: "immobilier", units: ["nuit", "semaine", "mois"] }, photos: [`${IMG}/loc_rent_apt.jpg`, `${IMG}/loc_apt_bedroom.jpg`, `${IMG}/loc_apt_kitchen.jpg`], desc: "Appartement meublé 2 pièces dans une résidence sécurisée de Riviera 2. Idéal courts et longs séjours, à 10 min du centre commercial.", equipments: ["2 chambres climatisées", "Wi-Fi haut débit", "Cuisine équipée", "Parking sécurisé", "Groupe électrogène", "Smart TV + Netflix"] },
      { id: "rav4", img: `${IMG}/loc_cat_vehicules.jpg`, name: "Toyota RAV4 2023", verified: true, rating: "4,7", reviews: "98", area: "Cocody", distance: "2,4 km", tags: ["SUV", "Automatique", "Avec chauffeur"], price_fcfa: 45000, price_prefix: "", price_unit: "/ jour", cta: "Réserver", rental_model: { type: "vehicule", units: ["jour", "semaine", "mois"], driver_options: ["avec chauffeur", "sans chauffeur"] }, photos: [`${IMG}/loc_cat_vehicules.jpg`, `${IMG}/loc_rav4_interior.jpg`, `${IMG}/loc_rav4_rear.jpg`], desc: "SUV récent, entretien à jour, parfait pour la ville comme pour les trajets vers l'intérieur du pays. Disponible avec ou sans chauffeur.", equipments: ["Boîte automatique", "Climatisation", "5 places + grand coffre", "Bluetooth / CarPlay", "Assurance tous risques", "Chauffeur en option"] },
      { id: "sonoprestige", img: `${IMG}/loc_cta.jpg`, name: "Sono Prestige CI", verified: true, rating: "4,8", reviews: "203", area: "Marcory", distance: "3,1 km", tags: ["Sono", "Éclairage", "Bâches"], price_fcfa: 25000, price_prefix: "À partir de", price_unit: "", cta: "Louer", rental_model: { type: "evenementiel", units: ["jour", "week-end"], event_fields: true }, photos: [`${IMG}/loc_cta.jpg`, `${IMG}/loc_sono_lights.jpg`, `${IMG}/loc_sono_mixer.jpg`], desc: "Pack sono complet pour mariages, baptêmes, anniversaires et conférences. Livraison, installation et technicien sur place.", equipments: ["2 enceintes 1 000 W", "Table de mixage", "2 micros sans fil", "Éclairage LED", "Bâches + 50 chaises", "Technicien inclus"] },
      { id: "groupeselectro", img: `${IMG}/loc_rent_gen.jpg`, name: "Groupes Électro CI", verified: true, rating: "4,6", reviews: "85", area: "Yopougon", distance: "4,5 km", tags: ["Groupe électrogène", "BTP"], price_fcfa: 15000, price_prefix: "À partir de", price_unit: "/ jour", cta: "Louer", rental_model: { type: "materiel", units: ["jour", "week-end", "semaine"], event_fields: true }, photos: [`${IMG}/loc_rent_gen.jpg`, `${IMG}/loc_gen_panel.jpg`, `${IMG}/loc_gen_row.jpg`], desc: "Groupes électrogènes 5 à 60 kVA pour chantiers, événements et commerces. Livraison sur site et mise en service incluses.", equipments: ["Groupes 5 – 60 kVA", "Carburant en option", "Livraison sur site", "Mise en service", "Câblage fourni", "Assistance 24h/7"] },
    ],
  },
  live: {
    title: "AYA Live",
    subtitle: "Des loueurs en direct près de vous",
    items: [
      { id: "sonolive", img: `${IMG}/loc_live_sono.jpg`, viewers: 124, title: "Comment choisir sa sono ?", tag: "Sono Prestige CI" },
      { id: "residlive", img: `${IMG}/loc_live_resid.jpg`, viewers: 89, title: "Visite d'une résidence meublée", tag: "Résidence Abidjan" },
    ],
  },
  trust: [
    { Icon: BadgeCheck, title: "Loueurs vérifiés", sub: "Identités et biens contrôlés" },
    { Icon: ShieldCheck, iconColor: "#E8A33D", title: "Réservation sécurisée", sub: "Paiement et caution protégés" },
  ],
};

// 2026-06 — Registre des biens à louer (fiches détaillées /bien/:id).
export const RENTALS_REGISTRY = Object.fromEntries(
  locationData.nearby.items.map((b) => [b.id, { ...b, back: "/location" }]),
);
